export default {
    forgottenShield: {icon: 'mdi-shield-sun', color: 'pale-light-blue', effect: [
        {name: 'horde_resilience', type: 'keepUpgrade', value: true},
        {name: 'horde_rest', type: 'keepUpgrade', value: true}
    ]},
    burningSkull: {icon: 'mdi-skull', color: 'orange-red', effect: [
        {name: 'horde_boneBag', type: 'keepUpgrade', value: true},
        {name: 'horde_anger', type: 'keepUpgrade', value: true}
    ]},
    energyDrink: {icon: 'mdi-bottle-soda', color: 'yellow', effect: [
        {name: 'currencyHordeMonsterPartGain', type: 'base', value: 0.5},
        {name: 'horde_monsterSoup', type: 'keepUpgrade', value: true}
    ]},
    luckyDice: {icon: 'mdi-dice-6', color: 'light-green', effect: [
        {name: 'horde_luckyStrike', type: 'keepUpgrade', value: true}
    ]},
    dumbbell: {icon: 'mdi-dumbbell', color: 'indigo', effect: [
        {name: 'horde_training', type: 'keepUpgrade', value: true}
    ]},
    bandage: {icon: 'mdi-bandage', color: 'pale-pink', effect: [
        {name: 'horde_thickSkin', type: 'keepUpgrade', value: true}
    ]},
    newBackpack: {icon: 'mdi-bag-personal', color: 'pale-orange', effect: [
        {name: 'horde_hoarding', type: 'keepUpgrade', value: true},
        {name: 'horde_plunderSecret', type: 'keepUpgrade', value: true}
    ]},
    ultimateGuide: {icon: 'mdi-book-multiple', color: 'brown', effect: [
        {name: 'horde_stabbingGuide', type: 'keepUpgrade', value: true},
        {name: 'horde_dodgingGuide', type: 'keepUpgrade', value: true}
    ]},
    crackedSafe: {icon: 'mdi-safe-square', color: 'darker-grey', effect: [
        {name: 'horde_looting', type: 'keepUpgrade', value: true}
    ]},
}
